import React, { useEffect, useState } from 'react';
import { MediaHelpers } from '@wajeez-web/core/api';
import { Slider } from '@wajeez-web/components/ui';
import { ImSpinner8 } from 'react-icons/im';
// import Slider from 'react-slick';

import {
  BaseComponentProps,
  useComponentData,
  useSkeletonHelper,
} from '../helpers/contentHooks';
import { ClickableComponentLayout } from '../layouts/ClickableComponentLayout';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';

export interface RepeatedAnyFullWidthHorizontalParameters {
  title: string | null;
  seeAllTitle: string | null;
}

interface RepeatedAnyFullWidthHorizontalProps extends BaseComponentProps {
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export function RepeatedAnyFullWidthHorizontal({
  component,
  context,
  setIsActive,
  isLastSibling = false,
}: RepeatedAnyFullWidthHorizontalProps) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    swipeToSlide: true,
  };

  const [pageNumber, setPageNumber] = useState(1);

  const { getParameterValue, contents, contentsRequestStatus, meta } =
    useComponentData<RepeatedAnyFullWidthHorizontalParameters>(
      component,
      context,
      pageNumber
    );

  const { lastElementRef } = useInfiniteScroll(
    meta?.hasNextPage,
    setPageNumber
  );

  const { isActive } = useSkeletonHelper(
    contentsRequestStatus,
    contents?.length ? true : false
  );

  const seeAllTitle = getParameterValue('seeAllTitle');
  const title = getParameterValue('title');

  useEffect(() => {
    setIsActive(isActive);
  }, [isActive, setIsActive]);

  return contents?.length ? (
    <div>
      <div className="flex justify-between space-y-[17px]">
        <div className="font-bold text-[20px]">{title}</div>
        {seeAllTitle && <div className=" text-[17px]">{seeAllTitle}</div>}
      </div>
      <div className="mt-[27px]">
        <div
          className={`w-full ${
            !isLastSibling && 'border-b-[0.5px]'
          } border-[#C6C6C8] dark:border-dark-divider`}
        >
          <Slider
            customStyle="pb-10 px-2 sm:pb-0 sm:px-0 sm:mr-[-30px] desktop:mr-[-20px]"
            childrenLength={contents?.length}
          >
            {contents?.map((content, i) => (
              <RepeatedAnyFullWidthHorizontalItem
                key={content.id}
                component={{ ...component?.itemTemplate, uniqueId: i }}
                context={content}
                isLastSibling={contents.length - 1 === i}
                ref={lastElementRef}
              />
            ))}
          </Slider>
          {/* <Slider {...settings}>
            {contents?.map((content, i) => (
              <RepeatedAnyFullWidthHorizontalItem
                key={content.id}
                component={{ ...component?.itemTemplate, uniqueId: i }}
                context={content}
                isLastSibling={contents.length - 1 === i}
                ref={lastElementRef}
              />
            ))}
            {contentsRequestStatus === 'loading' && (
              <div className="hidden sm:flex w-full justify-center items-center text-[24px] text-primary dark:text-primary-dark">
                <ImSpinner8 className="animate-spin mx-auto" />
              </div>
            )}
          </Slider> */}
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
}

export interface RepeatedAnyFullWidthHorizontalItemParameters {
  image: string | null;
}

const RepeatedAnyFullWidthHorizontalItem = React.forwardRef<
  HTMLDivElement,
  BaseComponentProps
>(({ component, context, isLastSibling }, ref) => {
  const { getParameterValue, content, isLockedContent } =
    useComponentData<RepeatedAnyFullWidthHorizontalItemParameters>(
      component,
      context
    );

  const image = getParameterValue('image');

  return (
    <div
      ref={ref}
      className={`flex-col w-[134px] sm:w-full sm:px-[30px] desktop:px-[20px] items-start justify-start`}
    >
      <ClickableComponentLayout content={content}>
        <div className="flex-col w-full items-start justify-start">
          <div
            style={{
              backgroundImage:
                'url(' + MediaHelpers.getPublicMediaById(image) + ')',
            }}
            className={`relative h-[134px] sm:h-[150px] 2xl:h-[130px] w-full border rounded-[10px] bg-cover bg-center bg-no-repeat mb-[4px] sm:mb-0`}
          >
            {isLockedContent && (
              <div className="w-[31px] h-[31px] absolute bottom-[10px] left-[10px]">
                <img
                  src="../../assets/images/lock.png"
                  alt="lock"
                  className="block w-full h-full"
                />
              </div>
            )}
          </div>
          <div className="mt-1 sm:mt-[16px] text-[15px] sm:text-[16px] sm:font-medium sm:text-black sm:text-right">
            {content?.title}
          </div>
          <div className="mt-1 sm:mt-0 text-[12px] sm:text-[15px] sm:font-medium text-[rgba(60, 60, 67, 0.6)] sm:text-[#545454] sm:text-right">
            {content?.authors?.toString().replaceAll(',', ' و ')}
          </div>
        </div>
      </ClickableComponentLayout>
    </div>
  );
});
